import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { IconGalleryComponent } from "./shared/common-components/icon-gallery/icon-gallery.component";
import { OnboardingComponent } from "./shared/common-components/onboarding/onboarding.component";
import { DesignElementsGalleryComponent } from "./shared/common-components/design-elements-gallery/design-elements-gallery.component";
import { StoryboardComponent } from "./storyboard/storyboard.component";

import { VideoXComponent } from "./video-x/video-x.component";
import { TermsOfServiceComponent } from "./terms-of-service/terms-of-service.component";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { HelpCenterComponent } from "./help-center/help-center.component";

const routes: Routes = [
  { path: "", redirectTo: "auth", pathMatch: "full" },
  {
    path: "auth",
    loadChildren: () => import("./auth/auth.module").then((m) => m.AuthModule),
  },
  {
    path: "admin/v2",
    loadChildren: () =>
      import("./layout/layout.module").then((m) => m.LayoutModule),
  },
  {
    path: "onboarding",
    component: OnboardingComponent,
  },
  {
    path: "onboarding",
    component: OnboardingComponent,
  },

  {
    path: "icons",
    component: IconGalleryComponent,
  },
  {
    path: "design-elements",
    component: DesignElementsGalleryComponent,
  },
  {
    path: "storyboard",
    component: StoryboardComponent,
  },

  {
    path: "video-x",
    component: VideoXComponent,
  },
  {
    path: "terms-of-service",
    component: TermsOfServiceComponent,
  },
  {
    path: "privacy-policy",
    component: PrivacyPolicyComponent,
  },
  {
    path: "help-center",
    component: HelpCenterComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "top",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
